"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Box_1 = tslib_1.__importDefault(require("@material-ui/core/Box"));
var index_1 = require("../../../index");
function Theme() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u5916\u89C2"),
        react_1.default.createElement(index_1.SelectButtonGroupView, { data: [{ text: "开启桌面通知" }] },
            react_1.default.createElement(index_1.SwitchButton, null)),
        react_1.default.createElement(Box_1.default, { m: 3 }),
        react_1.default.createElement(index_1.DesTitle, null, "\u4E3B\u9898"),
        react_1.default.createElement(index_1.SettingBoxRadioButtonGroupView, { data: [
                {
                    text: "黑暗",
                },
                {
                    text: "明亮",
                },
            ], onClick: function (item) { return console.log(item); } }),
        react_1.default.createElement(Box_1.default, { m: 3 }),
        react_1.default.createElement(index_1.DesTitle, null, "\u6D88\u606F\u7C7B\u578B"),
        react_1.default.createElement(index_1.SettingBoxRadioButtonGroupView, { data: [
                {
                    text: "舒适型：简单高效的现代化风格。",
                },
                {
                    text: "紧凑型：在一个窗口内显示尽可能多的消息，IRC 模式。",
                },
            ], onClick: function (item) { return console.log(item); } }),
        react_1.default.createElement(Box_1.default, { m: 3 }),
        react_1.default.createElement(index_1.DesTitle, null, "\u804A\u5929\u5B57\u4F53\u7F29\u653E"),
        react_1.default.createElement(index_1.SettingSlider, null),
        react_1.default.createElement(Box_1.default, { m: 3 })));
}
exports.Theme = Theme;
//# sourceMappingURL=Theme.js.map